import {
  GET_ORDERS_DATA,
  GET_ORDERS_DATA_SUCCESS,
  GET_ORDERS_DATA_FAILURE,
  UPDATE_ORDER,
  UPDATE_ORDER_SUCCESS,
  UPDATE_ORDER_FAILURE,
  DELETE_ORDER,
  DELETE_ORDER_SUCCESS,
  DELETE_ORDER_FAILURE,
  GET_ACTIVE_ORDERS,
  GET_ACTIVE_ORDERS_SUCCESS,
  GET_ACTIVE_ORDERS_FAILURE,
  GET_USER_ORDERS,
  GET_USER_ORDERS_SUCCESS,
  GET_USER_ORDERS_FAILURE
} from '../actions/orderActions';


const INITIAL_STATE = {
  userOrders: {
    data: [],
    status: null,
    error: null,
    loading: false,
  },
  activeOrders: {
    data: [],
    status: null,
    error: null,
    loading: false,
  },
  orders: {
    data: [],
    status: null,
    error: null,
    loading: false,
  },
  updated: {
    order: null,
    status: null,
    error: null,
    loading: false
  },
  deleted: {
    order: null,
    status: null,
    error: null,
    loading: false
  }
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_ORDERS_DATA:
      return {...state, orders: { data: [], status: 'fetching', error: null, loading: true } }
    case GET_ORDERS_DATA_SUCCESS:
      return {...state, orders: { data: action.payload.orders, status: 'fetched', error: null, loading: false } }
    case GET_ORDERS_DATA_FAILURE:
      return {...state, orders: { data: [], status: 'not-fetched', error: action.payload.error, loading: false } }

    case UPDATE_ORDER:
      return {...state, updated: { order: null, status: 'updating', error: null, loading: true } }
    case UPDATE_ORDER_SUCCESS:
      return {...state, updated: { order: action.payload.order, status: 'updated', error: null, loading: false } }
    case UPDATE_ORDER_FAILURE:
      return {...state, updated: { order: null, status: 'not-updated', error: action.payload.error, loading: false } }

    case DELETE_ORDER:
      return {...state, deleted: { order: null, status: 'deleting', error: null, loading: true } }
    case DELETE_ORDER_SUCCESS:
      return {...state, deleted: { order: action.payload.order, status: 'deleted', error: null, loading: false } }
    case DELETE_ORDER_FAILURE:
      return {...state, deleted: { order: null, status: 'not-deleted', error: action.payload.error, loading: false } }
    
    case GET_ACTIVE_ORDERS:
      return {...state, activeOrders: { data: [], status: 'fetching', error: null, loading: true } }
    case GET_ACTIVE_ORDERS_SUCCESS:
      return {...state, activeOrders: { data: action.payload.orders, status: 'fetched', error: null, loading: false } }
    case GET_ACTIVE_ORDERS_FAILURE:
      return {...state, activeOrders: { data: [], status: 'not-fetched', error: action.payload.error, loading: false } }

    case GET_USER_ORDERS:
      return {...state, userOrders: { data: [], status: 'fetching', error: null, loading: true }}
    case GET_USER_ORDERS_SUCCESS:
      return {...state, userOrders: { data: action.payload.orders, status: 'fetched', error: null, loading: false }}
    case GET_USER_ORDERS_FAILURE:
      return {...state, userOrders: { data: [], status: 'not-fetched', error: action.payload.error, loading: false }}
      
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/orderReducer.js